var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcHide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_hide",
    transform: "translate(-218 -382)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2194",
    "data-name": "Rectangle 2194",
    width: 16,
    height: 16,
    transform: "translate(218 382)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_visible_off",
    d: "M13.819,7.726A6.325,6.325,0,0,0,11.85,5.481L9.629,7.7a1.8,1.8,0,0,1-2.4,2.4L13.1,4.281a.632.632,0,1,0-.894-.894l-9.3,9.3a.632.632,0,1,0,.894.894l1.452-1.494a6.724,6.724,0,0,0,2.749.6,6.524,6.524,0,0,0,5.816-3.445,1.644,1.644,0,0,0,0-1.512ZM9.479,4.455A6.6,6.6,0,0,0,8,4.281,6.524,6.524,0,0,0,2.187,7.726a1.645,1.645,0,0,0,0,1.512A6.382,6.382,0,0,0,3.243,10.7Z",
    transform: "translate(217.997 381.799)",
    fill: "#141414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHide);
export default __webpack_public_path__ + "static/media/ic_hide.0f83c37753f5d1cf8bf89ed99d8a68e0.svg";
export { ForwardRef as ReactComponent };